import moment from 'moment';

export default class Wallet {
  static walletEnabled = {
    active: 1,
    disabled: 0
  };

  constructor({
    rowNum,
    id,
    mnemonic,
    address,
    addressTransfers,
    pubkey,
    cardLinkedAt,
    chipLinkedAt,
    mobileLinkedAt,
    enabled,
    status,
    updatedAt
  }) {
    this.rowNum = rowNum || null;
    this.id = id;
    this.mnemonic = mnemonic;
    this.address = address;
    this.addressTransfers = addressTransfers;
    this.pubkey = pubkey;
    this.cardLinkedAt = cardLinkedAt;
    this.chipLinkedAt = chipLinkedAt;
    this.mobileLinkedAt = mobileLinkedAt;
    this.enabled = enabled;
    this.status = status;
    this.updatedAt = updatedAt;
    this.expand();
  }

  expand() {
    let updatedAtFormatted = null;

    if (moment(this.updatedAt).isValid()) {
      updatedAtFormatted = moment(this.updatedAt).from();
    } else {
      updatedAtFormatted = null;
    }
    this.updatedAtFormatted = updatedAtFormatted;
  }

}
